import React from 'react'
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { formHelperTextClasses } from "@mui/material/FormHelperText";
import { styled } from "@mui/material/styles";
// import Box from '@mui/material/Box';
// import SvgIcon from '@mui/material/SvgIcon';
// import IconButton from '@mui/material/IconButton';
// import InputAdornment from '@mui/material/InputAdornment';
// import { ReactComponent as PlusIcon } from '../../images/icons/plus_icon.svg';
// import { ReactComponent as MinusIcon } from '../../images/icons/minus_icon.svg';

const StyledTextField = styled(TextField)(({ theme }) => ({
  [`& .${outlinedInputClasses.root}`]: {
    backgroundColor: 'var(--card-bg)',
    transition: 'background-color 0.3s ease',
  },
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderRadius: "8px",
    borderColor: 'var(--border-color)',
    transition: 'border-color 0.3s ease',
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'var(--border-color)',
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: 'var(--border-color)',
    boxShadow: "0px 0px 0px 1px var(--shadow-color)"
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: "var(--red-bnz)",
    boxShadow: "0px 0px 0px 1px rgba(241, 79, 92, 0.52)"    
  },
  [`& .${outlinedInputClasses.input}`]: {
    fontFamily: "'Inter', Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    paddingTop: "13px",
    paddingBottom: "13px",
    color: "var(--text-color)",
    transition: 'color 0.3s ease',
  },
  [`&:hover .${outlinedInputClasses.input}`]: {
    color: "var(--text-color)"
  },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.input}`]: {
    color: "var(--text-color)",
  },
  [`& .${outlinedInputClasses.input}::placeholder`]: {
    color: "var(--text-secondary)",
    opacity: 1,
    transition: 'color 0.3s ease',
  },
  [`& .${inputLabelClasses.outlined}`]: {
    color: "var(--text-secondary)",
    transition: 'color 0.3s ease',
  },
  [`&:hover .${inputLabelClasses.outlined}`]: {
    color: "var(--text-secondary)"
  },
  [`& .${inputLabelClasses.outlined}.${inputLabelClasses.focused}`]: {
    color: "var(--text-secondary)"
  },
  [`& .${formHelperTextClasses.root}`]: {
    color: "var(--text-secondary)",
    transition: 'color 0.3s ease',
  },
  [`& .${formHelperTextClasses.root}.${formHelperTextClasses.error}`]: {
    color: "var(--red-bnz)",
  }
}));

const CustomTextField = props => {

  // const [value, setValue] = useState();
  
  // const handleAddValue = () => {
  //   setValue(value + 1);
  // };

  // const handleSubtractValue = () => {
  //   setValue(value - 1);
  // }
  

  return (
    <StyledTextField
    fullWidth
    id={props.id}
    name={props.name}
    label={props.label}
    placeholder={props.placeholder}
    value={props.value}
    onChange={props.onChange}
    onBlur={props.onBlur}
    onKeyDown={props.onKeyDown}
    onKeyUp={props.onKeyUp}
    error={props.error}
    helperText={props.helperText}
    sx={props.sx}
    inputProps={props.inputProps}
    required={props.required}
    autoFocus={props.autoFocus}        
    InputLabelProps={{ shrink: true }}
    />
  )
}

export default CustomTextField